import { Routes } from '@angular/router';
import { PageNotFoundComponent } from '../shared/page-not-found/page-not-found.component';
import { NonAutorizzatoComponent } from '../shared/unauthorized/unauthorized.component';

export const errorRoutes: Routes = [
  { path: 'unauthorized', component: NonAutorizzatoComponent },
  { path: '**', component: PageNotFoundComponent },
];
